import * as Sentry from "@sentry/react";

import {
  getPortalLandingPath,
  getProviderLoginUrl,
} from "../util/portalRoutes";
import { useEffect, useRef } from "react";

import { Loading } from "@verse_core/shared_components/base/Loading";
import { getGoLinkFragment } from "./goLinkFragment";
import { safeInternalPath } from "../util/safeInternalPath";
import { useAuth0 } from "@auth0/auth0-react";

// Must match the go-link-token-exchange Action's subject token type in the infra repo
const GO_LINK_TOKEN_TYPE = "urn:versemedical:go-link";

export default function GoLinkLogin() {
  const { exchangeToken, isLoading } = useAuth0();
  // The token is single use, so StrictMode's second effect run must not resend it
  const exchangeStarted = useRef(false);

  useEffect(() => {
    if (isLoading || exchangeStarted.current) return;
    exchangeStarted.current = true;

    const params = new URLSearchParams(getGoLinkFragment());
    const token = params.get("token");
    const redirectTo =
      safeInternalPath(params.get("redirect_to")) ??
      getPortalLandingPath("provider");
    const loginUrl = getProviderLoginUrl(redirectTo);

    if (!token) {
      window.location.replace(loginUrl);
      return;
    }

    // Clear stale session state so useAuth falls back to roles[0] after login.
    sessionStorage.removeItem("authRedirect");
    localStorage.removeItem("activeRole");

    // replace() keeps the token out of history and reloads with the new session
    exchangeToken({
      subject_token: token,
      subject_token_type: GO_LINK_TOKEN_TYPE,
    })
      .then(() => window.location.replace(redirectTo))
      .catch((err) => {
        Sentry.captureException(err, {
          tags: { component: "GoLinkLogin", phase: "exchangeToken" },
        });
        window.location.replace(loginUrl);
      });
  }, [isLoading]);

  return <Loading />;
}
